import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const TOKEN_KEY = "kanggui_token";

export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (t) => localStorage.setItem(TOKEN_KEY, t);
export const clearToken = () => localStorage.removeItem(TOKEN_KEY);

const authHeader = () => {
  const t = getToken();
  return t ? { Authorization: `Bearer ${t}` } : {};
};

// cache-busting param so live CDN/browser never serves stale list data
const nc = () => ({ params: { _t: Date.now() } });
const ncAuth = () => ({ params: { _t: Date.now() }, headers: authHeader() });

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export const api = {
  login: (email, password) => axios.post(`${API}/auth/login`, { email, password }),
  me: () => axios.get(`${API}/auth/me`, { headers: authHeader() }),
  listNotices: () => axios.get(`${API}/notices`, nc()),
  createNotice: (data) => axios.post(`${API}/notices`, data, { headers: authHeader() }),
  updateNotice: (id, data) => axios.put(`${API}/notices/${id}`, data, { headers: authHeader() }),
  deleteNotice: (id) => axios.delete(`${API}/notices/${id}`, { headers: authHeader() }),
  createIdCard: (data) => axios.post(`${API}/idcards`, data),
  getIdCard: (id) => axios.get(`${API}/idcards/${id}`, nc()),
  lookupIdCard: (phone) => axios.get(`${API}/idcards/lookup/${encodeURIComponent(phone)}`, nc()),
  listIdCards: () => axios.get(`${API}/idcards`, ncAuth()),
  deleteIdCard: (id) => axios.delete(`${API}/idcards/${id}`, { headers: authHeader() }),
  setCardActive: (id, active) => axios.put(`${API}/idcards/${id}/active`, { active }, { headers: authHeader() }),
  rejectIdCard: (id, remark) => axios.put(`${API}/idcards/${id}/reject`, { remark }, { headers: authHeader() }),
  getSettings: () => axios.get(`${API}/settings`, nc()),
  updateSettings: (data) => axios.put(`${API}/settings`, data, { headers: authHeader() }),
  list: (res) => axios.get(`${API}/${res}`, nc()),
  create: (res, data) => axios.post(`${API}/${res}`, data, { headers: authHeader() }),
  update: (res, id, data) => axios.put(`${API}/${res}/${id}`, data, { headers: authHeader() }),
  remove: (res, id) => axios.delete(`${API}/${res}/${id}`, { headers: authHeader() }),
  bulkRecords: (data) => axios.post(`${API}/records/bulk`, data, { headers: authHeader() }),
  listBooks: () => axios.get(`${API}/books`, nc()),
  setLibraryImage: (image) => axios.put(`${API}/library/image`, { image }, { headers: authHeader() }),
  createApplication: (data) => axios.post(`${API}/applications`, data),
  listApplications: (params) => axios.get(`${API}/applications`, { params: { ...(params || {}), _t: Date.now() }, headers: authHeader() }),
  applicationStatus: (phone) => axios.get(`${API}/applications/status/${encodeURIComponent(phone)}`, nc()),
  getVisitors: () => axios.get(`${API}/visitors`, nc()),
  recordLookup: (q) => axios.get(`${API}/records/lookup`, { params: { q, _t: Date.now() } }),
  studentLookup: (q) => axios.get(`${API}/student/lookup`, { params: { q, _t: Date.now() } }),
  hitVisitor: () => axios.post(`${API}/visitors`, {}, nc()),
  deleteApplication: (id) => axios.delete(`${API}/applications/${id}`, { headers: authHeader() }),
  getApplication: (id) => axios.get(`${API}/applications/${id}`, { params: { _t: Date.now() }, headers: authHeader() }),
  updateApplicationStatus: (id, status, remark) => axios.put(`${API}/applications/${id}/status`, { status, remark }, { headers: authHeader() }),
  toggleForm: (formType, open) => axios.put(`${API}/forms/${formType}`, { open }, { headers: authHeader() }),
  createBook: (data) => axios.post(`${API}/books`, data, { headers: authHeader() }),
  updateBook: (id, data) => axios.put(`${API}/books/${id}`, data, { headers: authHeader() }),
  deleteBook: (id) => axios.delete(`${API}/books/${id}`, { headers: authHeader() }),
  listIssues: () => axios.get(`${API}/issues`, ncAuth()),
  createIssue: (data) => axios.post(`${API}/issues`, data, { headers: authHeader() }),
  returnIssue: (id) => axios.post(`${API}/issues/${id}/return`, {}, { headers: authHeader() }),
  deleteIssue: (id) => axios.delete(`${API}/issues/${id}`, { headers: authHeader() }),
};
